<template>
    <div id="contenedor-editar-auditoria">
        <v-form v-model="formularioValido" ref="editarAuditoria">
          <v-card flat>
            <v-card-title class="secondary--text mb-4">
            Editar Auditoría
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-subtitle>
            </v-card-subtitle>
            <v-card-text>
                <v-row>
                <div v-if="!$vuetify.breakpoint.xs"
                style="width: 150px" class="">
                <ejercicio-picker
                v-model="auditoria.ejercicio">
                </ejercicio-picker>
                </div>
                </v-row>
                <v-row>
                <custom-autocomplete
                  cols="12"
                  md="12"
                  v-model="auditoria.idEnteFiscalizador"
                  label="Ente Fiscalizador"
                  :items="getEntesFiscalizadores"
                  item-text="descripcion"
                  item-value="id"
                  clearable
                  :rules="[mixReglas.requerido]"
                  >
                </custom-autocomplete>
                </v-row>
                <v-row>
                <custom-text-area
                cols="12"
                v-model="auditoria.nombre"
                label="Nombre"
                rows="3"
                :rules="[mixReglas.requerido]">
              </custom-text-area>
               </v-row>
              <v-row>
                <custom-date-picker
                md="4"
                lg="4"
                v-model="auditoria.periodoDel"
                label="Del"
                :rules="[mixReglas.requerido]">
              </custom-date-picker>
                <custom-date-picker
                cols="12"
                md="4"
                lg="4"
                v-model="auditoria.periodoAl"
                label="Al"
                :rules="[mixReglas.requerido]"
                @input="validaFechas">
              </custom-date-picker>
              </v-row>
              <v-card class="selected ma-4 pa-4" flat>
              <v-row align="center" justify="center">
                <v-file-input
                v-show="false"
                show-size
                label="Seleccionar Archivo PDF"
                type="file"
                ref="anexoDocumento"
                name="anexo"
                id="anexo"
                accept=".pdf"
                @change="seleccion"
                >
                </v-file-input>
                <v-btn text large icon class="secondary--text" @click="seleccionarArchivo">
                    <v-icon center>
                      mdi-paperclip
                    </v-icon>
                </v-btn>
                <template v-if="nombreArchivoSeleccionado">
                  <span class="text-caption font-weight-light secondary--text" >
                    {{ nombreArchivoSeleccionado }}</span>
                </template>
                <template v-else>
                  <span class="text-caption font-weight-light secondary--text">
                    ... </span>
                </template>
              </v-row>
              <v-row align="center" justify="center">
              <custom-button
                  class="mx-4 text-caption font-weight-light"
                  tipo="formCancelar"
                  :label="rutaArchivo || nombreArchivoSeleccionado
                  ? 'Cambiar' : 'Seleccionar Archivo'"
                  @click="seleccionarArchivo">
                </custom-button>
              </v-row>
              </v-card>
            </v-card-text>
            <v-divider class="bkground" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
          </v-card>
        </v-form>

    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import mixAuditorias from './mixAuditorias';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';

export default {
  name: 'EditarAuditoria',
  props: {
    auditoriaEditar: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixAuditorias, mixDescargarArchivo],
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      rutaArchivo: null,
      nombreArchivoSeleccionado: null,
      archivoAnexo: null,
      auditoria: {
        idEnteFiscalizador: this.auditoriaEditar.idEnteFiscalizador,
        nombre: this.auditoriaEditar.nombre,
        ejercicio: this.auditoriaEditar.ejercicio,
        periodoDel: this.auditoriaEditar.periodoDel,
        periodoAl: this.auditoriaEditar.periodoAl,
        fileData: this.auditoriaEditar.fileData,
      },
      documento: {
        path: '',
        nombre: '',
      },
    };
  },
  components: {
    CustomAutocomplete,
    CustomButton,
    CustomDatePicker,
    CustomTextArea,
    EjercicioPicker,
  },
  mounted() {
    if (this.auditoriaEditar.fileData !== null) {
      this.nombreArchivoSeleccionado = 'PDF Auditoria';
    }
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarAuditoria.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    seleccion() {
      if (document.getElementById('anexo').files.length === 1) {
        this.rutaArchivo = URL.createObjectURL(
          document.getElementById('anexo').files[0],
        );
        this.nombreArchivoSeleccionado = document.getElementById('anexo').files[0].name;
      }
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    async guardar() {
      this.enviandoFormulario = true;
      const datosArchivo = this.setDatosArchivo();
      if (this.rutaArchivo !== null) {
        const archivo = await this.mixSubirArchivo(datosArchivo);
        if (archivo.status === 'ok') {
          this.auditoria.fileData = JSON.stringify(archivo.data);
        }
      }
      await this.mixActualizarAuditoria();
    },
    setDatosArchivo() {
      const datos = {
        // nombre: `${this.nombreArchivoSeleccionado}`,
        nombre: 'auditoria',
        path: 'Auditorias/',
      };
      return datos;
    },
    validaFechas() {
      if (new Date(this.auditoria.periodoDel) > new Date(this.auditoria.periodoAl)) {
        this.auditoria.periodoAl = '';
      }
    },
  },
};
</script>
